import { render, staticRenderFns } from "./publishComment.vue?vue&type=template&id=0f07b215&scoped=true"
import script from "./publishComment.vue?vue&type=script&lang=js"
export * from "./publishComment.vue?vue&type=script&lang=js"
import style0 from "./publishComment.vue?vue&type=style&index=0&id=0f07b215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07b215",
  null
  
)

export default component.exports